import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";
export const managementAssetGroupCategory = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/asset-group-category",

  state: {
    recommendations: undefined,
  },
  getters: {
    recommendations(state) {
      return state.recommendations;
    },
  },
  mutations: {
    recommendations(state, value) {
      state.recommendations = value;
    },
  },
  actions: {
    async paginateRecommendation({ commit, dispatch }, { pagination, level, id }, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("recommendations", undefined);
        }
        const response = await dispatch("paginate", pagination);
        commit("recommendations", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
  },
});
export const workspaceAssetGroupCategory = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/asset-group-category",

  state: {
    recommendations: undefined,
  },
  getters: {
    recommendations(state) {
      return state.recommendations;
    },
  },
  mutations: {
    recommendations(state, value) {
      state.recommendations = value;
    },
  },
  actions: {
    async paginateRecommendation({ commit, dispatch }, { pagination, level, id }, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("recommendations", undefined);
        }
        const response = await dispatch("paginate", pagination);
        commit("recommendations", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
  },
});

export const managementAssetGroup = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/asset-group",
});
export const workspaceAssetGroup = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/asset-group",
});

export const assetGroupCategory = createCrudVuexModule({
  namespaced: true,
  path: "/library/asset-group-category",

  state: {
    recommendations: undefined,
  },
  getters: {
    recommendations(state) {
      return state.recommendations;
    },
  },
  mutations: {
    recommendations(state, value) {
      state.recommendations = value;
    },
  },
  actions: {
    async paginateRecommendation({ commit }, { pagination, level, id }, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("recommendations", undefined);
        }
        const response = await rest.post(`/recommendation/paginate/asset-group-category`, { pagination });
        commit("recommendations", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
    // async paginateRecommendation({ commit, dispatch }, { pagination, level, id }, clearStateBeforeRest = false) {
    //   commit("isLoading", true);
    //   try {
    //     if (clearStateBeforeRest) {
    //       commit("recommendations", undefined);
    //     }

    //     const response = await dispatch("paginate", pagination);
    //     commit("recommendations", response.data);
    //     return response;
    //   } finally {
    //     commit("isLoading", false);
    //   }
    // },
  },
});

export const assetGroup = createCrudVuexModule({
  namespaced: true,
  path: "/library/asset-group",

  state: {
    recommendations: undefined,
  },
  getters: {
    recommendations(state) {
      return state.recommendations;
    },
  },
  mutations: {
    recommendations(state, value) {
      state.recommendations = value;
    },
  },
  actions: {
    async paginateRecommendation({ commit }, { pagination, level, id }, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("recommendations", undefined);
        }
        const response = await rest.post(`/recommendation/paginate/${level}/${id}`, { pagination });
        commit("recommendations", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
  },
});
